<div class="finish-day-button-wrapper">
  <!-- NOTE: tabindex is same as for tasks -->
  @if (hasDoneTasks()) {
    <button
      [matTooltip]="T.WW.FINISH_DAY_TOOLTIP | translate"
      color="primary"
      mat-flat-button
      routerLink="/active/daily-summary"
      tabindex="1"
      class="e2e-finish-day"
    >
      <mat-icon>done_all</mat-icon>
      {{ T.WW.FINISH_DAY | translate }}
    </button>
  } @else {
    <button
      [matTooltip]="T.WW.FINISH_DAY_TOOLTIP | translate"
      color=""
      mat-stroked-button
      routerLink="/active/daily-summary"
      tabindex="1"
      class="e2e-finish-day"
    >
      <mat-icon>done_all</mat-icon>
      {{ T.WW.FINISH_DAY | translate }}
    </button>
  }
</div>
